import { Skeleton } from "@/components/ui/skeleton";

export function RecordingSkeleton() {
  return (
    <section>
      <div className="mb-5 rounded-[calc(var(--radius)+2px)] border border-border p-1">
        <Skeleton className="aspect-video w-full rounded-lg bg-muted" />
      </div>
      <div className="h-6 w-3/4 animate-pulse rounded-md bg-gray-200" />
    </section>
  );
}
